// ---------------------------------------------
// auto-generated from materia/course.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MSourceRail, MNotAdvice, MChart, MRail } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";

// ─────────────────────────────────────────────────────────
// Shared shell for Course screens · with course rail
// ─────────────────────────────────────────────────────────
export const CourseShell = ({ label, leftRail = true, center, right, sourceProps, current = 2 }) => (
  <div className="m-screen-d materia" data-screen-label={label}>
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="map"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <div className="m-topbar">
          <div className="m-breadcrumb">
            <span>EducaFinaz</span><span className="sep">/</span>
            <span>Aprender</span><span className="sep">/</span>
            <span>Curso</span><span className="sep">/</span>
            <span className="now">AT iniciación</span>
          </div>
          <div style={{ flex: 1, display: "flex", justifyContent: "center", gap: 10, alignItems: "center" }}>
            <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>módulos</span>
            {[1,2,3,4,5,6].map(i => (
              <div key={i} style={{
                width: 22, height: 22, borderRadius: 4,
                background: i < current ? "rgba(155,184,106,0.16)" : i === current ? "rgba(201,122,75,0.20)" : "var(--m-metal-2)",
                border: `1px solid ${i < current ? "rgba(155,184,106,0.4)" : i === current ? "var(--m-primary)" : "var(--m-line)"}`,
                color: i < current ? "var(--m-positive)" : i === current ? "var(--m-primary)" : "var(--m-text-3)",
                display: "grid", placeItems: "center",
                fontSize: 10, fontFamily: "var(--m-t-mono)", fontWeight: 600,
              }}>{i === 6 ? "P" : i}</div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <MChip variant="copper">COURSE · iniciación</MChip>
            <MChip variant="warn">mastery · 80%</MChip>
            <button className="m-iconbtn"><Icon name="more" size={15}/></button>
          </div>
        </div>

        <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
          {leftRail && (
            <div style={{ width: 280, borderRight: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>
              <CourseSidebar/>
            </div>
          )}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
            {center}
          </div>
          {right && (
            <div style={{ width: 360, borderLeft: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>
              {right}
            </div>
          )}
        </div>
        <MSourceRail {...sourceProps}/>
      </div>
    </div>
  </div>
);

export const CourseSidebar = ({ active = "M3" }) => (
  <div style={{ padding: 18, overflow: "auto", flex: 1 }}>
    <MEye>AT iniciación · 6 módulos</MEye>
    <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4 }}>
      {[
        { l: "M1", t: "Qué es AT y qué no es", s: "done", d: "32 min" },
        { l: "M2", t: "Anatomía del gráfico", s: "done", d: "35 min" },
        { l: "M3", t: "Tendencias y estructura", s: "now", d: "40 min" },
        { l: "M4", t: "Soportes y resistencias", s: "next", d: "45 min" },
        { l: "M5", t: "Volumen básico", s: "next", d: "30 min" },
        { l: "P",  t: "Proyecto · mapa técnico", s: "future", d: "60 min", proj: true },
      ].map((m, i) => {
        const c = m.s === "done" ? "var(--m-positive)" :
                  m.s === "now"  ? "var(--m-primary)" :
                  m.s === "next" ? "var(--m-accent)" : "var(--m-text-3)";
        return (
          <button key={i} style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "8px 10px", borderRadius: 4,
            background: m.l === active ? "rgba(201,122,75,0.10)" : "transparent",
            border: m.l === active ? "1px solid var(--m-primary)" : "1px solid transparent",
            cursor: "pointer", textAlign: "left", color: "var(--m-text)",
          }}>
            <span style={{
              width: 26, height: 26, borderRadius: m.proj ? 4 : 99,
              border: `1.5px solid ${c}`,
              background: m.s === "done" ? "rgba(155,184,106,0.18)" : m.s === "now" ? "rgba(201,122,75,0.18)" : "transparent",
              color: c, fontFamily: "var(--m-t-mono)", fontSize: 10, fontWeight: 600,
              display: "grid", placeItems: "center", flexShrink: 0,
            }}>{m.l}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: m.s === "now" ? 600 : 400 }}>{m.t}</div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 2 }}>{m.d}</div>
            </div>
            {m.s === "done" && <Icon name="check" size={11} style={{ color: "var(--m-positive)" }}/>}
            {m.s === "now" && <Icon name="play" size={11} style={{ color: "var(--m-primary)" }}/>}
          </button>
        );
      })}
    </div>

    <div className="m-divider" style={{ margin: "16px 0" }}/>

    <MEye>Mastery del curso</MEye>
    <div className="m-meter" style={{ marginTop: 8 }}>
      <div className="fill" style={{ width: "32%" }}/>
      <div className="threshold" style={{ left: "80%" }}/>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, fontFamily: "var(--m-t-mono)", fontSize: 10, color: "var(--m-text-3)" }}>
      <span>32%</span>
      <span>threshold 80%</span>
    </div>

    <div className="m-divider" style={{ margin: "16px 0" }}/>

    <MEye>Tutor persistente</MEye>
    <div className="m-panel" style={{ marginTop: 8, padding: 10, display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ width: 30, height: 30, borderRadius: 99, background: "rgba(216,168,104,0.16)", display: "grid", placeItems: "center" }}>
        <Icon name="help" size={13} style={{ color: "var(--m-accent)" }}/>
      </div>
      <div>
        <div style={{ fontSize: 11.5, fontWeight: 600 }}>Carlos · profesor_analista</div>
        <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 1 }}>contexto · M3 · A3</div>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
// 1. Course · Hub Overview
// ─────────────────────────────────────────────────────────
export const ScreenMCHub = () => (
  <CourseShell
    label="Course · Hub Overview"
    leftRail={false}
    sourceProps={{ note: "EDU.COURSE.AT.INICIACION_READ_CHARTS · v3.1 · 6 módulos · proyecto final" }}
    center={
      <div style={{ flex: 1, padding: "30px 56px", overflow: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <MEye>Curso · iniciación · ~5 h</MEye>
            <h1 className="m-serif" style={{ fontSize: 52, fontWeight: 600, letterSpacing: "-0.03em", margin: "10px 0 8px", lineHeight: 1.0, fontStyle: "normal" }}>
              Análisis técnico, <em style={{ color: "var(--m-accent)" }}>iniciación</em>.
            </h1>
            <div style={{ fontSize: 19, color: "var(--m-text-2)", maxWidth: 640, lineHeight: 1.4, textWrap: "pretty" }}>
              Leer gráficos sin autoengañarse. Vas a leer velas, volumen y timeframes con criterio prudente.
            </div>
          </div>
          <div className="m-panel" style={{ padding: 16, width: 240 }}>
            <MEye>Tu progreso</MEye>
            <div className="m-meter" style={{ marginTop: 12 }}>
              <div className="fill" style={{ width: "0%" }}/>
              <div className="threshold" style={{ left: "80%" }}/>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
              <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>0%</span>
              <span className="mono" style={{ fontSize: 11, color: "var(--m-warn)" }}>mastery 80%</span>
            </div>
            <div className="m-divider" style={{ margin: "12px 0" }}/>
            <div style={{ fontSize: 11.5, color: "var(--m-text-2)" }}>Diagnóstico inicial 4 min ajustará la ruta.</div>
          </div>
        </div>

        {/* Module map horizontal */}
        <div className="m-panel" style={{ marginTop: 30, padding: 24 }}>
          <MEye>6 módulos · proyecto final</MEye>
          <div style={{ marginTop: 20, display: "flex", alignItems: "center", gap: 4 }}>
            {[
              { l: "M1", t: "Qué es AT", d: "30 min" },
              { l: "M2", t: "Anatomía", d: "35 min" },
              { l: "M3", t: "Tendencias", d: "40 min" },
              { l: "M4", t: "S/R", d: "45 min" },
              { l: "M5", t: "Volumen", d: "30 min" },
              { l: "P",  t: "Proyecto", d: "60 min", proj: true },
            ].map((m, i, arr) => (
              <React.Fragment key={i}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, flexShrink: 0, width: 124 }}>
                  <div style={{
                    width: 58, height: 58, borderRadius: m.proj ? 8 : 99,
                    border: "1.5px solid var(--m-line-strong)",
                    background: "var(--m-metal-2)",
                    color: "var(--m-text-2)",
                    fontFamily: "var(--m-t-mono)", fontSize: 14, fontWeight: 600,
                    display: "grid", placeItems: "center",
                    boxShadow: "var(--m-bevel-top)",
                  }}>{m.l}</div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: 12, fontWeight: 600 }}>{m.t}</div>
                    <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 2 }}>{m.d}</div>
                  </div>
                </div>
                {i < arr.length - 1 && (
                  <div style={{ flex: 1, height: 2, background: "rgba(216,196,160,0.12)", marginBottom: 28 }}/>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 24, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>5 objetivos clave</MEye>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                "Separar AT de predicción",
                "Leer vela, OHLC, volumen y timeframe",
                "Identificar tendencias por estructura",
                "Dibujar soportes como zonas",
                "Producir un mapa técnico prudente",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 12, fontSize: 13.5, lineHeight: 1.4 }}>
                  <span className="mono" style={{ color: "var(--m-accent)", width: 24, flexShrink: 0 }}>0{i+1}</span>
                  <span style={{ textWrap: "pretty" }}>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="m-misconception" style={{ padding: 22 }}>
            <div className="lbl">Errores que evitarás</div>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                "AT no predice con certeza",
                "Más líneas no es mejor análisis",
                "Una vela aislada no basta",
                "Cruce ≠ ruptura",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 10, fontSize: 13.5, lineHeight: 1.4, color: "var(--m-text-2)" }}>
                  <Icon name="x" size={14} style={{ color: "var(--m-warn)", marginTop: 3, flexShrink: 0 }}/>
                  <span style={{ textWrap: "pretty" }}>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Project preview */}
        <div className="m-panel" style={{ marginTop: 18, padding: 22, display: "flex", alignItems: "center", gap: 22, border: "1px dashed rgba(201,122,75,0.4)" }}>
          <Icon name="diamond" size={32} style={{ color: "var(--m-primary)" }}/>
          <div style={{ flex: 1 }}>
            <MEye>Proyecto final · evaluado por rubric pública</MEye>
            <div className="m-serif" style={{ fontSize: 22, marginTop: 4, fontStyle: "normal", letterSpacing: "-0.015em" }}>
              Mapa técnico simple de un activo no visto.
            </div>
            <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 4 }}>Identificar tendencia · marcar zonas · declarar invalidación · fuente y timestamp</div>
          </div>
        </div>

        <div style={{ marginTop: 28, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Icon name="shield" size={14} style={{ color: "var(--m-text-3)" }}/>
            <MNotAdvice>Certificado pedagógico · no es certificación financiera</MNotAdvice>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button className="m-btn"><Icon name="map" size={13}/> Ver mapa</button>
            <button className="m-btn primary lg"><Icon name="play" size={14}/> Empezar diagnóstico · 4 min</button>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 2. Module M2 Overview (now showing M3 to match sidebar)
// ─────────────────────────────────────────────────────────
export const ScreenMCModule = () => (
  <CourseShell
    label="Course · Module M3 Overview"
    current={3}
    sourceProps={{ note: "EDU.COURSE · M3 Tendencias y estructura · 40 min · ARCH.retail_consumer activable" }}
    center={
      <div style={{ flex: 1, padding: "32px 48px", overflow: "auto" }}>
        <MEye>Módulo M3 · 40 min · 1 microclase + 1 lab + caso vivo + mastery</MEye>
        <h1 className="m-serif" style={{ fontSize: 44, fontWeight: 600, letterSpacing: "-0.025em", margin: "10px 0 8px", lineHeight: 1.05, fontStyle: "normal" }}>
          Tendencias y <em style={{ color: "var(--m-accent)" }}>estructura</em>.
        </h1>
        <div style={{ fontSize: 16, color: "var(--m-text-2)", maxWidth: 660, lineHeight: 1.45, textWrap: "pretty" }}>
          Aprenderás a reconocer una tendencia por la secuencia de máximos y mínimos, no por el color de la vela.
        </div>

        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
          <div className="m-panel" style={{ padding: 18 }}>
            <MEye>Objetivos del módulo</MEye>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                "Identificar HH, HL, LH, LL en charts reales",
                "Distinguir tendencia de movimiento lateral",
                "Confirmar tendencia con multi-timeframe básico",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 10, fontSize: 13, lineHeight: 1.4 }}>
                  <Icon name="check" size={13} style={{ color: "var(--m-positive)", marginTop: 3, flexShrink: 0 }}/>
                  <span style={{ textWrap: "pretty" }}>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="m-misconception" style={{ padding: 18 }}>
            <div className="lbl">Errores que evitas</div>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                "Confundir vela roja con cambio de tendencia",
                "Confundir lateralidad con cambio de tendencia",
                "Trazar tendencias en timeframes inadecuados",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 10, fontSize: 13, lineHeight: 1.4, color: "var(--m-text-2)" }}>
                  <Icon name="x" size={13} style={{ color: "var(--m-warn)", marginTop: 3, flexShrink: 0 }}/>
                  <span style={{ textWrap: "pretty" }}>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div style={{ marginTop: 22 }}>
          <MEye>Agenda</MEye>
          <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              { n: "1", t: "Microclase · estructura de tendencia", d: "6 min", i: "movie", on: true },
              { n: "2", t: "Lab · etiquetar swings en chart real", d: "12 min", i: "draw" },
              { n: "3", t: "Caso vivo · semana actual",          d: "~5 min", i: "globe", live: true },
              { n: "4", t: "Tutor clinic · 2 misconceptions",      d: "10 min", i: "help" },
              { n: "5", t: "Mastery check · 8 ejercicios",         d: "7 min", i: "target" },
              { n: "6", t: "Retention loop · mañana / día 4 / día 10", d: "futuro", i: "spark", future: true },
            ].map((s, i) => (
              <div key={i} className="m-panel" style={{
                padding: "12px 14px", display: "flex", alignItems: "center", gap: 14,
                background: s.on ? "rgba(201,122,75,0.08)" : "var(--m-metal-2)",
                borderColor: s.on ? "var(--m-primary)" : "var(--m-line)",
              }}>
                <span className="mono" style={{
                  width: 28, height: 28, display: "grid", placeItems: "center",
                  borderRadius: 99, border: "1px solid var(--m-line)",
                  color: s.on ? "var(--m-primary)" : "var(--m-text-3)", fontSize: 11, fontWeight: 600,
                }}>{s.n}</span>
                <Icon name={s.i} size={15} style={{ color: s.future ? "var(--m-text-3)" : s.live ? "var(--m-positive)" : s.on ? "var(--m-primary)" : "var(--m-text-2)" }}/>
                <span style={{ flex: 1, fontSize: 13.5, color: s.future ? "var(--m-text-3)" : "var(--m-text)" }}>{s.t}</span>
                {s.live && <MChip variant="live">live</MChip>}
                <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>{s.d}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>
            density · medium · voz · profesor_analista · re-render más simple disponible
          </div>
          <button className="m-btn primary lg"><Icon name="play" size={14}/> Empezar microclase</button>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 3. Mastery Check
// ─────────────────────────────────────────────────────────
export const ScreenMCMastery = () => (
  <CourseShell
    label="Course · MasteryCheck"
    current={3}
    sourceProps={{ note: "M3 · MasteryCheck · 8 ejercicios + 1 transfer · threshold 80%" }}
    right={
      <div style={{ flex: 1, padding: 18, overflow: "auto" }}>
        <MEye>Mastery meter · M3</MEye>
        <div className="m-meter" style={{ marginTop: 12 }}>
          <div className="fill" style={{ width: "72%" }}/>
          <div className="threshold" style={{ left: "80%" }}/>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, fontFamily: "var(--m-t-mono)", fontSize: 11 }}>
          <span style={{ color: "var(--m-text)" }}>72%</span>
          <span style={{ color: "var(--m-warn)" }}>threshold 80%</span>
        </div>
        <div className="m-divider" style={{ margin: "14px 0" }}/>

        <MEye>Progreso por ejercicio</MEye>
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4 }}>
          {[
            { n: 1, t: "Tipo · TF",     s: "ok" },
            { n: 2, t: "Tipo · MC",     s: "ok" },
            { n: 3, t: "Chart label",   s: "ok" },
            { n: 4, t: "Compare",       s: "ok" },
            { n: 5, t: "Replay decis.", s: "fail" },
            { n: 6, t: "Chart label",   s: "now" },
            { n: 7, t: "Combine",       s: "todo" },
            { n: 8, t: "Transfer task", s: "todo" },
          ].map((e, i) => (
            <div key={i} style={{
              padding: "6px 10px", borderRadius: 4,
              background: e.s === "now" ? "rgba(201,122,75,0.10)" : "transparent",
              borderLeft: `2px solid ${
                e.s === "ok" ? "var(--m-positive)" :
                e.s === "fail" ? "var(--m-negative)" :
                e.s === "now" ? "var(--m-primary)" : "var(--m-line)"
              }`,
              display: "flex", alignItems: "center", gap: 8,
            }}>
              <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)", width: 18 }}>{e.n}</span>
              <span style={{ flex: 1, fontSize: 11.5, color: e.s === "todo" ? "var(--m-text-3)" : "var(--m-text-2)" }}>{e.t}</span>
              {e.s === "ok" && <Icon name="check" size={11} style={{ color: "var(--m-positive)" }}/>}
              {e.s === "fail" && <Icon name="x" size={11} style={{ color: "var(--m-negative)" }}/>}
              {e.s === "now" && <span className="mono" style={{ fontSize: 9.5, color: "var(--m-primary)" }}>NOW</span>}
            </div>
          ))}
        </div>

        <div className="m-divider" style={{ margin: "14px 0" }}/>
        <MEye>Falta para mastery</MEye>
        <div style={{ marginTop: 8, fontSize: 12, color: "var(--m-text-2)", lineHeight: 1.4 }}>
          1 acierto + 1 transferencia válida. Si no llegas hoy, no estás bloqueado: te ofrecemos remediación.
        </div>

        <div className="m-divider" style={{ margin: "14px 0" }}/>
        <MEye>Tutor disponible</MEye>
        <button className="m-btn ghost sm" style={{ width: "100%", justifyContent: "flex-start", marginTop: 8 }}>
          <Icon name="help" size={11}/> Preguntar al tutor
        </button>
      </div>
    }
    center={
      <div style={{ flex: 1, padding: "24px 32px", overflow: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <MChip variant="copper">CHART LABELING</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>ejercicio 6 de 8</span>
          <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
          <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>sin timer · sin penalización</span>
        </div>
        <h2 style={{ fontSize: 24, fontWeight: 600, marginTop: 14, lineHeight: 1.25, letterSpacing: "-0.015em" }}>
          Etiqueta el <span style={{ color: "var(--m-accent)" }}>HL</span> que mantiene la tendencia.
        </h2>

        <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1.7fr 1fr", gap: 20 }}>
          <div style={{ position: "relative" }}>
            <MChart width={580} height={360} caption="ABC · 1D · 28 sesiones"
              overlays={[
                { type: "trend", from: [10, 84], to: [90, 36], color: "rgba(216,168,104,0.4)", dashed: true },
              ]}/>
            {[
              { x: 18, y: 78, l: "1" },
              { x: 36, y: 60, l: "2", glow: true },
              { x: 58, y: 44, l: "3" },
              { x: 80, y: 30, l: "4" },
            ].map((s, i) => (
              <div key={i} style={{
                position: "absolute",
                left: `calc(${s.x}% - 22px)`, top: `calc(${s.y}% - 22px)`,
                width: 44, height: 44, borderRadius: 99,
                border: `1.5px solid ${s.glow ? "var(--m-accent)" : "rgba(216,168,104,0.4)"}`,
                background: s.glow ? "rgba(216,168,104,0.18)" : "rgba(216,168,104,0.06)",
                display: "grid", placeItems: "center",
                boxShadow: s.glow ? "0 0 24px rgba(216,168,104,0.4)" : "none",
              }}>
                <span className="mono" style={{ fontSize: 11.5, color: s.glow ? "var(--m-accent)" : "var(--m-text-2)" }}>{s.l}</span>
              </div>
            ))}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <MEye>Etiquetas</MEye>
              <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                {[
                  { l: "HH", c: "var(--m-positive)" },
                  { l: "HL", c: "var(--m-positive)", on: true },
                  { l: "LH", c: "var(--m-negative)" },
                  { l: "LL", c: "var(--m-negative)" },
                ].map((b, i) => (
                  <button key={i} className="m-chip" style={{
                    height: 38, padding: "0 14px", fontSize: 13,
                    background: b.on ? `color-mix(in oklab, ${b.c} 18%, transparent)` : "rgba(216,196,160,0.06)",
                    borderColor: b.on ? b.c : "var(--m-line)",
                    color: b.on ? b.c : "var(--m-text-2)",
                    justifyContent: "center",
                  }}>{b.l}</button>
                ))}
              </div>
            </div>

            <div className="m-misconception" style={{ padding: 14 }}>
              <div className="lbl">misconception observada · M3</div>
              <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
                En el ej. 5 confundiste color de vela con cambio de estructura. Continúa atento aquí.
              </div>
            </div>

            <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="m-btn ghost sm"><Icon name="lightbulb" size={11}/> Pista 1/3</button>
                <button className="m-btn ghost sm"><Icon name="list" size={11}/> Accesible</button>
              </div>
              <button className="m-btn accent lg"><Icon name="check" size={14}/> Enviar respuesta</button>
            </div>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 4. Diagnostic Intake
// ─────────────────────────────────────────────────────────
export const ScreenMCDiagIntake = () => (
  <CourseShell
    label="Course · Diagnostic Intake"
    leftRail={false}
    current={1}
    sourceProps={{ note: "Diagnóstico inicial · 4 ejercicios cortos · sin penalización · ajusta ruta" }}
    center={
      <div style={{ flex: 1, padding: "30px 56px", overflow: "auto", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <MChip variant="warn">diagnóstico · sin penalización</MChip>
            <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>1 / 4 · 4 min restantes</span>
          </div>
          <button className="m-btn ghost sm"><Icon name="x" size={11}/> Saltar diagnóstico</button>
        </div>

        {/* Progress dots */}
        <div style={{ marginTop: 18, display: "flex", gap: 6 }}>
          {[1,2,3,4].map(i => (
            <div key={i} style={{
              flex: 1, height: 4, borderRadius: 2,
              background: i === 1 ? "var(--m-text)" : "rgba(216,196,160,0.12)",
            }}/>
          ))}
        </div>

        <h1 className="m-serif" style={{ fontSize: 32, fontWeight: 600, lineHeight: 1.2, letterSpacing: "-0.02em", margin: "26px 0 6px", fontStyle: "normal", textWrap: "balance" }}>
          ¿Qué describe mejor este movimiento?
        </h1>
        <div style={{ fontSize: 13, color: "var(--m-text-2)" }}>Esto no se evalúa. Solo nos ayuda a ajustar la ruta.</div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 24, flex: 1, minHeight: 0 }}>
          <MChart width={580} height={360} caption="EJEMPLO · 1D"
            overlays={[
              { type: "trend", from: [12, 70], to: [90, 38], color: "rgba(216,168,104,0.6)" },
              { type: "swing", xPct: 22, yPct: 76, label: "HL" },
              { type: "swing", xPct: 50, yPct: 56, label: "HL" },
              { type: "swing", xPct: 78, yPct: 36, label: "HH" },
            ]}/>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              { l: "Subida sin retrocesos", d: "evoluciona en línea recta sin volver atrás" },
              { l: "Tendencia con máximos crecientes", d: "alterna avances y retrocesos, pero sube" , on: true },
              { l: "Mercado lateral", d: "se mueve dentro de un rango sin tendencia clara" },
              { l: "No lo sé · prefiero verlo después", d: "el sistema te ofrecerá una microclase corta" },
            ].map((o, i) => (
              <div key={i} className={`m-option ${o.on ? "selected" : ""}`}>
                <div className="radio"/>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13.5, fontWeight: 500 }}>{o.l}</div>
                  <div style={{ fontSize: 11, color: "var(--m-text-3)", marginTop: 2, lineHeight: 1.35 }}>{o.d}</div>
                </div>
                <span className="m-kbd">{i+1}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>
            ⌥ tu respuesta no afecta el progreso · sólo la ruta inicial
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="m-btn"><Icon name="next" size={13}/> Saltar pregunta</button>
            <button className="m-btn primary lg"><Icon name="check" size={14}/> Enviar y continuar</button>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 5. Diagnostic Result
// ─────────────────────────────────────────────────────────
export const ScreenMCDiagResult = () => (
  <CourseShell
    label="Course · Diagnostic Result"
    leftRail={false}
    current={1}
    sourceProps={{ note: "Ruta personalizada · revisable en cualquier momento · sin penalización" }}
    center={
      <div style={{ flex: 1, padding: "30px 56px", overflow: "auto" }}>
        <MEye>Diagnóstico completado · 4 / 4</MEye>
        <h1 className="m-serif" style={{ fontSize: 44, fontWeight: 600, letterSpacing: "-0.025em", margin: "10px 0 8px", lineHeight: 1.05, fontStyle: "normal" }}>
          Tu nivel inicial: <em style={{ color: "var(--m-accent)" }}>medio</em>.
        </h1>
        <div style={{ fontSize: 16, color: "var(--m-text-2)", maxWidth: 620 }}>Lo confirmamos en M3. Puedes cambiarlo en perfil.</div>

        <div style={{ marginTop: 28, display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 20 }}>
          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>Empezaremos por</MEye>
            <div style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ width: 60, height: 60, borderRadius: 99, background: "rgba(201,122,75,0.18)", border: "1.5px solid var(--m-primary)", display: "grid", placeItems: "center", color: "var(--m-primary)", fontFamily: "var(--m-t-mono)", fontSize: 18, fontWeight: 600 }}>M2</div>
              <div>
                <div style={{ fontSize: 19, fontWeight: 600, letterSpacing: "-0.01em" }}>Anatomía del gráfico</div>
                <div style={{ fontSize: 12.5, color: "var(--m-text-2)", marginTop: 4 }}>Omitiremos M1 (Qué es AT y qué no). Lo dominas.</div>
              </div>
            </div>
            <div className="m-divider" style={{ margin: "18px 0" }}/>
            <MEye>Tu ruta ajustada · 5 módulos</MEye>
            <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 6 }}>
              {[
                { l: "M1", omit: true },
                { l: "M2", now: true },
                { l: "M3" },
                { l: "M4" },
                { l: "M5" },
                { l: "P", proj: true },
              ].map((m, i, arr) => (
                <React.Fragment key={i}>
                  <div style={{
                    width: 42, height: 42, borderRadius: m.proj ? 4 : 99,
                    border: m.omit ? "1px dashed var(--m-text-3)" : `1.5px solid ${m.now ? "var(--m-primary)" : "var(--m-line-strong)"}`,
                    background: m.omit ? "transparent" : m.now ? "rgba(201,122,75,0.18)" : "var(--m-metal-2)",
                    color: m.omit ? "var(--m-text-3)" : m.now ? "var(--m-primary)" : "var(--m-text-2)",
                    fontFamily: "var(--m-t-mono)", fontSize: 11, fontWeight: 600,
                    display: "grid", placeItems: "center", opacity: m.omit ? 0.4 : 1,
                  }}>{m.l}</div>
                  {i < arr.length - 1 && <div style={{ flex: 1, height: 1, background: "rgba(216,196,160,0.15)" }}/>}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div className="m-panel" style={{ padding: 18 }}>
              <MEye>Tu confianza declarada</MEye>
              <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 8 }}>
                {[0,1,2,3,4].map(i => (
                  <span key={i} style={{ width: 26, height: 26, borderRadius: 4, background: i < 2 ? "var(--m-text-2)" : "rgba(216,196,160,0.12)" }}/>
                ))}
              </div>
              <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 10 }}>2/5 · medirás de nuevo al final del curso</div>
            </div>
            <div className="m-panel" style={{ padding: 18 }}>
              <MEye>Tu objetivo declarado</MEye>
              <div className="m-serif" style={{ fontSize: 15, marginTop: 8, fontStyle: "italic", lineHeight: 1.4, color: "var(--m-text-2)" }}>
                "Quiero leer gráficos sin autoengañarme."
              </div>
              <button className="m-btn ghost sm" style={{ marginTop: 8 }}><Icon name="draw" size={10}/> Editar</button>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 28, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button className="m-btn"><Icon name="map" size={13}/> Ver mapa completo</button>
          <button className="m-btn primary lg"><Icon name="play" size={14}/> Empezar M2</button>
        </div>
      </div>
    }
  />
);
